import { config } from '@/lib';

const Item = (props) => {
  const { star, index, data, clickfrom } = props;

  var list = data.list || []; // 主播信息列表
  var max = data.max || list.length; // 最大需要显示的数量
  var showLive = data.showLive || true; // 是否需要显示直播中icon
  var showCount = data.showCount || true; // 是否需要显示房间人数
  var showCover = data.showCover || false; // 是否需要鼠标浮动封面，首页推荐位使用
  var isRedirect = data.isRedirect === false ? false : true; //是否默认支持点击跳转
  var type = data.type || 'inner'; // 主播信息显示在内还是在外
  var isLazy = data.isLazy ? data.isLazy : false; //是否延迟加载图片
  var saId = data.saId || ''; //神策事件ID

  // var star = list[i];
  var starId = star.star_id || star.id || star._id;
  var pic = star.app_pic_url || star.pic || star.pic_url;

  const linkProps = {};
  if (isRedirect || star.isRedirect) {
    linkProps.href = `/${starId}?clickfrom=${clickfrom}`;
    linkProps.target = '_blank';
  }

  return (
    <a
      className={`star-item star-item-${type} star-${starId}`}
      data-id={starId}
      data-index={index}
      data-sawebclick={`${saId ? 'id=' + saId + '&desc=' + starId : ''}`}
      {...linkProps}
    >
      <div className="star-avatar">
        {isLazy ? (
          <img
            className="lazyimg"
            src={config.defaultImg}
            data-original={pic}
            alt={star.nick_name}
            title={star.nick_name}
          />
        ) : (
          <img src={pic} alt={star.nick_name} title={star.nick_name} />
        )}
      </div>
      <div className="star-item-info">
        <div className="star-nickname text-overflow">{star.nick_name}</div>
        {showCount && (
          <div className="star-visiter-count">
            {star.fakeCount}
            {star.unit && <span>{star.unit}</span>}
          </div>
        )}
      </div>
      {showCover ? (
        <div className="select-cover">
          <img src={star.pic || config.defaultImg} alt={star.nick_name} />
        </div>
      ) : (
        <i className="icon-live-circle"></i>
      )}

      {showLive && star.live && <i className="icon-live"></i>}
    </a>
  );
};

const RoomList = (props) => {
  const { data, clickfrom } = props;
  var list = data.list || []; // 主播信息列表
  var max = data.max || list.length; // 最大需要显示的数量
  var showLive = data.showLive || true; // 是否需要显示直播中icon
  var showCount = data.showCount || true; // 是否需要显示房间人数
  var showCover = data.showCover || false; // 是否需要鼠标浮动封面，首页推荐位使用
  var isRedirect = data.isRedirect === false ? false : true; //是否默认支持点击跳转
  var type = data.type || 'inner'; // 主播信息显示在内还是在外
  var isLazy = data.isLazy ? data.isLazy : false; //是否延迟加载图片
  var saId = data.saId || ''; //神策事件ID

  if (list.length > Math.min(max, list.length)) {
    list = list.slice(0, Math.min(max, list.length));
  }

  return (
    <>
      {list.map((star, index) => {
        var starId = star.star_id || star.id || star._id;
        return (
          <Item
            key={starId}
            star={star}
            index={index}
            data={data}
            clickfrom={clickfrom}
          ></Item>
        );
      })}
    </>
  );
};

export default RoomList;
